import React from 'react';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import '@trp-beacon-ui-kit/foundation/css/style.css';
import { Box, Grid } from '@mui/material';


import introImage from '../../assets/images/intro-image.png';
import { RicBeaconButton } from './BeaconRegister';
import MGPHubView from '../../containers/MGPHubView'
import { matchPathname } from '../../Utils';
import { baseURLs, nextStepsURLs, notLandingURLs, includeQueryParams, SECURE_URL } from './Links';

const Content = ({ applicationConfig }) => {
    const [loadGuestProfile, setLoadGuestProfile] = React.useState(false);

    return (
        <Box className='beacon-theme-modern-outlook' >
            <Box sx={{ display: 'flex' }} id="intro-tile">
                <Box className='b-container' sx={{ inlineSize: 'unset' }}>
                    <Box>
                        <Grid container sx={{ display: 'flex' }}>
                            <Grid item size={{ xs: 12, lg: 9 }} sx={{ padding: '48px 0' }}>
                                <Box
                                    display="flex"
                                    alignItems="end"
                                >
                                    <Box
                                        className='b-typography-serif--headline--300'
                                        id="intro-tile-header-text"
                                    >
                                        Tell us a little about you and your household, then our retirement
                                        tool will give you an estimate of where you stand for retirement.
                                    </Box>
                                </Box>
                                <Box
                                    display="flex"
                                    alignItems="end"
                                >
                                    <Box
                                        className='b-typography-sans-serif--body-loose--100'
                                        sx={{ paddingTop: '16px', paddingBottom: { xs: '4px', sm: '32px' } }}
                                        id="intro-tile-sub-text"
                                    >
                                        Once you have your results, we’ll suggest a variety of potential
                                        actions that can help you prepare for retirement. You can also
                                        test out different scenarios to see how changes you make can
                                        impact your likelihood of success.
                                    </Box>
                                </Box>
                                {matchPathname(baseURLs).length &&
                                    !matchPathname(notLandingURLs).length &&
                                    !loadGuestProfile ?
                                    (
                                        <Box
                                            display="flex"
                                            alignItems="end"
                                        >
                                            <Box sx={{
                                                display: { md: 'flex', sm: 'block' },
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <Box sx={{ margin: { xs: '20px 0', sm: '32px 0', md: '0 20px 0 0' }}}>
                                                    <RicBeaconButton
                                                        onClick={() => {
                                                            window.location.replace(includeQueryParams(SECURE_URL))
                                                        }}
                                                        variant="primary"
                                                        id="login-signup"
                                                    >
                                                        Log In or Sign Up
                                                    </RicBeaconButton>
                                                </Box>
                                                <Box sx={{ margin: { sm: '32px 0', md: '0 20px 0 0' } }}>
                                                    <RicBeaconButton
                                                        variant='secondary'
                                                        onClick={() => {
                                                            setLoadGuestProfile(true);
                                                        }}
                                                        id="start"
                                                    >
                                                        Start Without Saving
                                                    </RicBeaconButton>
                                                </Box>
                                            </Box>
                                        </Box>
                                    ) :
                                    ('')
                                }
                            </Grid>
                            <Grid item size={{ xs: 12, md: 3 }} sx={{ display: { xs: 'none', lg: 'inherit' } }}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        height: '100%',
                                        background: '#FFFFFF',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}>
                                    <img
                                        style={{
                                            height: '255px',
                                            width: '371px'
                                        }}
                                        src={introImage}
                                        alt="intro-icon"
                                        id="intro-tile-intro-icon"
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Box>
            {loadGuestProfile && (
                <div style={{ minWidth: '100%' }}>
                    <MGPHubView applicationConfig={applicationConfig} />
                </div>
            )}
        </Box>
    );
};

const IntroTile = ({ applicationConfig }) => {

    if (!matchPathname(nextStepsURLs).length) {
        return (
            <Content applicationConfig={applicationConfig} />
        );
    }
    return <div />;
};

export default IntroTile;
